import React, { useRef } from "react";
import { Modal, Typography, Space, Divider, Tag, Button, Row, Col } from "antd";
import { PrinterOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

function formatMoney(n) {
    if (n === null || n === undefined || Number.isNaN(Number(n))) return "-";
    return new Intl.NumberFormat(undefined, { style: "currency", currency: "USD" }).format(Number(n));
}

function formatDate(d) {
    try {
        const dt = new Date(d);
        if (Number.isNaN(dt.getTime())) return d || "-";
        return dt.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "2-digit" });
    } catch {
        return d || "-";
    }
}

export default function TransactionReceiptModal({
                                                    open,
                                                    onClose,
                                                    data = {
                                                        company: "The Church of Pentecost U.S.A., Inc.",
                                                        source: "Others",
                                                        id: 1631035,
                                                        user_name: "Samuel Sintim",
                                                        benificiary_type: 3,
                                                        benificiary_id: 1367,
                                                        title: "Payment Receipt",
                                                        date: "2025-11-05",
                                                        reference: "2025 Ministers & Wives Conference Travel",
                                                        type: "Bank Transfer",
                                                        debit: 0,
                                                        credit: 3029.52,
                                                        head: "Global Ministers Conference-54180",
                                                        bank_account: "JP Morgan Chase Internal Missions Account-3950930020-JP Morgan Chase",
                                                        beneficiary: "Vendor > Rev. Francis K. Nkrumah",
                                                    },
                                                }) {
    const printRef = useRef(null);

    console.log("Data : "+ JSON.stringify(data));

    const handlePrint = () => {
        // Print the whole page but style ensures only .print-area is visible
        window.print();
    };

    const amountTag = (
        <Space size={8} wrap>
            {Number(data.debit) > 0 && <Tag color="red">Debit: {formatMoney(data.debit)}</Tag>}
            {Number(data.credit) > 0 && <Tag color="green">Credit: {formatMoney(data.credit)}</Tag>}
        </Space>
    );

    const beneficiaryTypeMap = {
        1: "Member",
        2: "Department",
        3: "Vendor",
    };

    return (
        <>
            {/* Print styles */}
            <style>
                {`
                @page { size: A4; margin: 10mm; }
          @media print {
                  body {
                background: white !important;
                -webkit-print-color-adjust: exact !important; /* ensures color accuracy */
                print-color-adjust: exact !important;
              }

            body * { visibility: hidden; }
            .print-area, .print-area * { visibility: visible; }
            .print-area { position: absolute; inset: 0; margin: 0; padding: 0; }
            .no-print { display: none !important; }
            .receipt-card {
              box-shadow: none !important;
              border: none !important;
            }
            .receipt-container {
              padding: 16px !important;
            }
          }
          .receipt-card {
            background: #fff;
            border-radius: 12px;
            box-shadow: 0 6px 18px rgba(0,0,0,0.06);
            border: 1px solid #f0f0f0;
          }
          .receipt-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            gap: 16px;
          }
          .muted { color: rgba(0,0,0,0.55); }
          .mono { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace; }
          .receipt-footer {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 16px;
          }
          .sig-line {
            margin-top: 40px;
            border-top: 1px dashed #999;
            padding-top: 6px;
            text-align: center;
            color: rgba(0,0,0,0.65);
          }
        `}
            </style>

            <Modal
                open={open}
                onCancel={onClose}
                footer={
                    <Space className="no-print">
                        <Button onClick={onClose}>Close</Button>
                        <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                            Print
                        </Button>
                    </Space>
                }
                width={760}
                title={null}
                destroyOnClose
            >
                {/* On-screen details */}

                {/* PRINT-ONLY RECEIPT (clean layout) */}
                <div className="print-area" ref={printRef} style={{ padding: 24 }}>
                    <div className="receipt-container receipt-card" style={{ padding: 24 }}>
                        <div className="receipt-header">
                            <div>
                                <Title level={4} style={{ margin: 0 }}>
                                    {Number(data.debit) > 0 ? "Receipt" : "Payment"}
                                </Title>
                                <Text className="muted">{data?.company}</Text>
                            </div>
                            <Space direction="vertical" align="end" size={2}>
                                <Text className="muted">Trx ID</Text>
                                <Text strong className="mono">#{data.id}</Text>
                                <Text className="muted">{formatDate(data.date)}</Text>
                            </Space>
                        </div>

                        <Divider />

                        <Row gutter={[16, 12]}>
                            <Col span={12}>
                                <Text className="muted">Reference</Text>
                                <div><Text strong>{data.reference || "-"}</Text></div>
                            </Col>
                            <Col span={12}>
                                <Text className="muted">Account</Text>
                                <div><Text strong>{data.head || "-"}</Text></div>
                            </Col>
                            <Col span={12}>
                                <Text className="muted">Payment Method</Text>
                                <div><Text strong>{data.type || "-"}</Text></div>
                            </Col>
                            <Col span={12}>
                                <Text className="muted">Source</Text>
                                <div><Text strong>{data.source || "-"}</Text></div>
                            </Col>
                            <Col span={24}>
                                <Text className="muted">Bank Account</Text>
                                <div><Text strong>{data.bank_account || "-"}</Text></div>
                            </Col>
                            <Col span={24}>
                                <Text className="muted">{
                                    Number(data.debit) > 0 ? "Payee": "Beneficiary"
                                }</Text>
                                <div>
                                    <Text strong>
                                        {data.beneficiary || "-"}{" "}
                                        {data.benificiary_id ? <span className="muted"> (ID: {data.benificiary_id})</span> : null}
                                    </Text>
                                </div>
                            </Col>
                            <Col span={12}>
                                <Text className="muted">Created By</Text>
                                <div><Text>{data.user_name || "-"}</Text></div>
                            </Col>
                            <Col span={12}>
                                <Text className="muted">
                                    {
                                        Number(data.debit) > 0 ? "Payee Type": "Beneficiary Type"
                                    }
                                    </Text>
                                <div><Text>{beneficiaryTypeMap[data.benificiary_type] || String(data.benificiary_type || "-")}</Text></div>
                            </Col>
                        </Row>

                        <Divider />

                        <Row>
                            <Col span={24}>
                                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                    <thead>
                                    <tr>
                                        <th style={{ textAlign: "left", padding: "8px 0" }}>Description</th>
                                        {/*<th style={{ textAlign: "right", padding: "8px 0" }}>Receipt</th>*/}
                                        <th style={{ textAlign: "right", padding: "8px 0" }}>Amount</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td style={{ padding: "6px 0" }}>{data.reference || "Payment"}</td>
                                        <td style={{ textAlign: "right", padding: "6px 0" }}>
                                            {Number(data.debit) > 0 ? formatMoney(data.debit) : formatMoney(data.credit)}
                                        </td>
                                    </tr>
                                    </tbody>
                                    <tfoot>
                                    <tr>
                                        <td style={{ borderTop: "1px solid #ddd", paddingTop: 8 }}><strong>Total</strong></td>
                                        <td style={{ borderTop: "1px solid #ddd", paddingTop: 8, textAlign: "right" }}>
                                            {Number(data.debit) > 0 ? <strong>{formatMoney(data.debit)}</strong> : formatMoney(data.credit)}
                                        </td>
                                    </tr>
                                    </tfoot>
                                </table>
                            </Col>
                        </Row>

                        <Divider />

                        <div className="receipt-footer">
                            <div>
                                <Text className="muted">Notes</Text>
                                <div style={{ marginTop: 4 }}>
                                    <Text>
                                        This receipt acknowledges the {data.type?.toLowerCase() || "payment"} recorded on{" "}
                                        {formatDate(data.date)} for the reference “{data.reference}”.
                                    </Text>
                                </div>
                            </div>
                            <div>
                                <Text className="muted">For</Text>
                                <div style={{ marginTop: 4 }}>
                                    <Text strong>{data.company}</Text>
                                </div>
                            </div>
                        </div>

                        <Row gutter={16} style={{ marginTop: 24, display: "none" }}>
                            <Col span={12}>
                                <div className="sig-line">Authorized Signature</div>
                            </Col>
                            <Col span={12}>
                                <div className="sig-line">{Number(data.debit) > 0 ? "Received" : "Paid"} By</div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Modal>
        </>
    );
}
